import { TextField, Button, Stack, Alert, Typography, Paper } from '@mui/material';
import { useAuth } from 'contexts';
import { User } from 'firebase/auth';
import { ChangeEvent, useState } from 'react';

interface Props {}

export const UserProfile = (props: Props) => {
    const resendEmailVerificationIntervalMinutes = 5;
    const authContext = useAuth();
    const [user, setUser] = useState(authContext.currentUser!);
    const [error, setError] = useState('');

    const onTextChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const fieldName = event.target.getAttribute('data-field') as keyof User;

        setUser({
            ...user,
            [fieldName]: event.target.value as string
        });
    };

    const onResendVerificationEmail = () => {
        authContext.sendVerifyEmail();
    };

    const onSaveChanges = () => {
        if (!user?.displayName) {
            return setError('Please enter a display name');
        }
        setError('');
        authContext.updateUserDisplayName(user.displayName ?? '');
    };

    const resendVerificationEmailEnableDate = new Date();
    resendVerificationEmailEnableDate.setMinutes(resendVerificationEmailEnableDate.getMinutes() - resendEmailVerificationIntervalMinutes);
    const canSendVerificationEmail =
        !authContext.lastEmailVerificationSentAt || authContext.lastEmailVerificationSentAt! < resendVerificationEmailEnableDate;

    return (
        <Paper className="aq-content" sx={{height: "100%"}}>
            <Stack spacing={2} direction="column" width={350}>
                {error && <Alert severity="error">{error}</Alert>}
                <TextField
                    id="txt-display-name"
                    label="Display Name"
                    variant="outlined"
                    fullWidth
                    onChange={onTextChange}
                    value={user?.displayName ?? ''}
                    inputProps={{ 'data-field': 'displayName' }}
                    InputLabelProps={{ shrink: !!user?.displayName }}
                />

                {!user.emailVerified && (
                    <div>
                        <Typography variant="body1" gutterBottom>
                            Please verify your e-mail by clicking the link in the e-mail you received (or will receive shortly).
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            If you do not receive the verification e-mail, please try resending the verification e-mail by clicking the button below.
                        </Typography>
                        <Button variant="contained" fullWidth onClick={onResendVerificationEmail} disabled={!canSendVerificationEmail}>
                            Resend e-mail verification
                        </Button>
                        {!canSendVerificationEmail && (
                            <Alert severity="info">e-mail verification sent. Can be resent again after 5 minutes.</Alert>
                        )}
                    </div>
                )}

                <Button variant="contained" onClick={onSaveChanges}>
                    Save
                </Button>
            </Stack>
        </Paper>
    );
};
